import React from 'react'

const Manual_enviar_notificacion_apps_dashboard_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Enviar notificación para apps desde el Dashboard de Clau.io
        </h2>
        <iframe
          src="https://scribehow.com/embed/Enviar_notificacion_para_apps_desde_el_Dashboard_de_Clauio__ZOkJcqnDQpCKeRZ1hdTNEQ?as=scrollable"
          className="scribe-iframe-general-85"
          width="100%"
          height="6700"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_enviar_notificacion_apps_dashboard_clau
